/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'project-contributors-picker.done': 'Понятно',
  'project-contributors-picker.go-back-label': 'Назад',
  'project-contributors-picker.header': 'Выбор участников проекта',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} участник} few {{membersCount,number} участника} many {{membersCount,number} участников} other {{membersCount,number} участника}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Выберите из {membersCount,number} участника} few {Выберите из {membersCount,number} участников} many {Выберите из {membersCount,number} участников} other {Выберите из {membersCount,number} участника}}',
  'project-contributors-picker.your-teams-title': 'Ваши команды',
  'project-fields.common.generic-error.description': 'Проверьте подключение к Интернету и повторите попытку.',
  'project-fields.common.generic-error.title': 'Произошла ошибка',
  'project-fields.link-item.delete-label': 'Удалить',
  'project-fields.link-item.edit-label': 'Редактировать',
  'project-fields.project-contributes-to.add-goal-title': 'Добавить цель',
  'project-fields.project-contributes-to.empty-title': 'Нет целей',
  'project-fields.project-contributes-to.title': 'Способствует работе над',
  'project-fields.project-contributors.add-contributors-title': 'Добавить участников',
  'project-fields.project-contributors.empty-title': 'Нет участников',
  'project-fields.project-contributors.remove-contributor': 'Удалить участника',
  'project-fields.project-contributors.remove-contributor-error-message': 'Не удалось удалить участника',
  'project-fields.project-contributors.remove-team': 'Удалить команду',
  'project-fields.project-contributors.show-more': 'Показать еще',
  'project-fields.project-contributors.title': 'Участники',
  'project-fields.project-contributors.view-profile': 'Просмотреть профиль',
  'project-fields.project-contributors.view-profile-team': 'Просмотреть профиль',
  'project-fields.project-focus-areas.title': 'Приоритетные направления',
  'project-fields.project-followers.add-followers-title': 'Добавить подписчиков',
  'project-fields.project-followers.empty-title': 'Нет подписчиков',
  'project-fields.project-followers.title': 'Подписчики',
  'project-fields.project-link-picker.aria-label': 'Недавно просмотренные ссылки',
  'project-fields.project-link-picker.invalid-link-input.error':
    'Убедитесь, что ссылка является действительным URL-адресом.',
  'project-fields.project-link-picker.link-input.clear-label': 'Стереть ссылку',
  'project-fields.project-link-picker.link-input.placeholder':
    'Вставьте ссылку или выполните поиск по недавно просмотренным',
  'project-fields.project-link-picker.text-input.clear-label': 'Удалить текст',
  'project-fields.project-link-picker.text-input.placeholder': 'Текст для отображения (необязательно)',
  'project-fields.project-links.add-links-title': 'Добавить ссылки',
  'project-fields.project-links.add-links-tooltip': 'Добавить ссылки на документы, варианты дизайна и др.',
  'project-fields.project-links.delete-link-button': 'Удалить ссылку',
  'project-fields.project-links.edit-link-button': 'Изменить ссылку',
  'project-fields.project-links.empty-title': 'Нет ссылок',
  'project-fields.project-links.title': 'Ссылки',
  'project-fields.project-owner.title': 'Владелец',
  'project-fields.project-start-date.add-start-date-title': 'Добавить дату начала',
  'project-fields.project-start-date.cancel-button': 'Сохранить',
  'project-fields.project-start-date.creation-date': 'Проект создан {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Изменить дату начала проекта',
  'project-fields.project-start-date.empty-title': 'Нет даты начала',
  'project-fields.project-start-date.enter-start-date-title': 'Введите дату начала',
  'project-fields.project-start-date.open-calendar-label': 'Открыть календарь',
  'project-fields.project-start-date.read-only':
    'Изменить дату начала могут только участники с правом на редактирование.',
  'project-fields.project-start-date.title': 'Дата начала',
  'project-fields.project-state.archived': 'Архивированные',
  'project-fields.project-state.at-risk': 'В зоне риска',
  'project-fields.project-state.cancelled': 'Отменено',
  'project-fields.project-state.completed': 'Выполнено 🎉',
  'project-fields.project-state.off-track': 'С отставанием от графика',
  'project-fields.project-state.on-track': 'По графику',
  'project-fields.project-state.paused': 'Приостановлено',
  'project-fields.project-state.pending': 'В ожидании',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Другие статусы',
  'project-fields.project-status.title': 'Статус',
  'project-fields.project-tags.add-tags-title': 'Добавить теги',
  'project-fields.project-tags.empty-title': 'Нет тегов',
  'project-fields.project-tags.title': 'Теги',
  'project-fields.project-target-date.picker-placeholder': 'В ожидании',
  'project-fields.project-target-date.title': 'Целевая дата',
  'project-fields.project-work-items.show-all-non-final': 'Показать все',
  'project-fields.project-work-items.show-less-non-final': 'Свернуть',
  'project-fields.project-work-tracked-picker.cancel-button': 'Сохранить',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Добавьте ссылку на место, где вы будете отслеживать работу над проектом',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Введите допустимый URL-адрес',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Поиск задач Jira',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Выполните поиск задач Jira или добавьте ссылки на места, где вы отслеживаете работу над проектом.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Попробуйте повторно ввести ключ или URL-адрес задачи Jira либо использовать другой поисковый запрос.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Нет задач, соответствующих запросу',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Недавно просмотренные',
  'project-fields.project-work-tracked-picker.results-title': 'Результаты',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Выполните поиск в Jira или добавьте ссылку',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Свяжите этот проект с выбранной задачей Jira для автоматической синхронизации сведений.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Обратите внимание, что сведения о проекте будут видны всем, кто может видеть эту задачу Jira.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Синхронизировать с Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Отмена',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Подключиться',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Выберите сведения, которые хотите использовать для выполнения работы:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Синхронизируйте этот проект с Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Синхронизация меток',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Синхронизируйте метки из Jira c тегами в проекте',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Название проекта',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Дата начала',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Целевая дата',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Ссылка для отслеживания работы',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Выполните поиск задач Jira или добавьте ссылки на места, где вы отслеживаете задачи в проекте.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Где отслеживается работа?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Добавить задачи Jira',
  'project-fields.project-work-tracked.empty-title': 'Нет задач Jira',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Связана с Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Синхронизировать',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Синхронизируется с Jira',
  'project-fields.project-work-tracked.title': 'Отслеживаемые задачи',
  'project-fields.related-project-picker.add-button-label': 'Добавить',
  'project-fields.related-project-picker.cancel-button-label': 'Отмена',
  'project-fields.related-project-picker.depended-by-option-label': 'От проекта зависят',
  'project-fields.related-project-picker.depends-on-option-label': 'Проект зависит от',
  'project-fields.related-project-picker.empty-state-description':
    'Найдите связанные проекты для привязки к этому проекту.',
  'project-fields.related-project-picker.empty-state-title': 'Поиск проектов',
  'project-fields.related-project-picker.project-relationship-type-label': 'Выберите тип взаимосвязи проектов',
  'project-fields.related-project-picker.project-search-placeholder': 'Поиск проектов',
  'project-fields.related-project-picker.related-option-label': 'Проект связан с',
  'project-fields.related-project-picker.related-project-list-label': 'Связанные проекты',
  'project-fields.related-projects.add-related-title': 'Добавить связанные проекты',
  'project-fields.related-projects.add-related-tooltip': 'Добавить зависимые или связанные проекты',
  'project-fields.related-projects.dependent-by-projects-heading': 'Зависимости проектов',
  'project-fields.related-projects.dependent-on-projects-heading': 'Зависит от',
  'project-fields.related-projects.empty-title': 'Нет связанных проектов',
  'project-fields.related-projects.related-projects-heading': 'Связан с',
  'project-fields.related-projects.title': 'Связанные',
  'project-fields.use-project-flags.generic-error-description':
    'Произошла ошибка. Повторите попытку через несколько минут.',
  'project-fields.use-project-flags.generic-error-title': 'Произошла ошибка',
  'project-fields.use-project-flags.project-links-add-failure-title': 'Не удалось добавить ссылку',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Не удалось удалить ссылку',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Не удалось отредактировать ссылку',
  'project-fields.use-project-flags.project-owner-change-error-header': 'Не удалось изменить владельца проекта',
  'project-fields.use-project-flags.project-start-date-change-error-header': 'Не удалось изменить дату начала проекта',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'Не удалось добавить тег',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Не удалось создать тег',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'Введено слишком длинное имя тега. Введите имя тега длиной не более 255 символов.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Не удалось создать тег',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Не удалось удалить тег',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'Ошибка при удалении команды. Повторите попытку',
  'project-fields.use-project-flags.related-project-remove-failure-title': 'Не удалось удалить связанный проект',
};
